/**
 * @typedef AccountResponse
 * @property {number} id
 * @property {object} user
 * @property {number} user.id
 * @property {string} user.first_name
 * @property {string} user.last_name
 * @property {string} user.email
 * @property {'Owner'|'Admin'|'Collaborator'|'Billing'} role
 * @property {boolean} disable_sso
 * @property {boolean} enforce_sso
 * @property {'active'|'invited'} status
 * @property {boolean} is_2fa_enabled
 * @property {string[]} survey_access
 * @property {string[]} team_member_mapping_emails
 * @property {boolean} is_custom_login
 * @property {string[]} login_methods
 */

const userDomain = {
  transformAccountsToAntdDataSource,
  canSeeOptionsV2,
  canTransferOwnerShip,
  canConfigureTeamMemberMapping,
  getAuthorizedDashboardTokens,
}

export default userDomain

/**
 *
 * @param {AccountResponse[]} accounts
 * @returns {import("components/UsersTable").User[]}
 */
function transformAccountsToAntdDataSource(accounts) {
  return accounts.map((account) => {
    return {
      key: account.id,
      id: account.id,
      name: [(account.user.first_name || '').trim(), (account.user.last_name || '').trim()]
        .join(' ')
        .trim(),
      email: account.user.email,
      role: account.role,
      disable_sso: account.disable_sso,
      enforce_sso: account.enforce_sso,
      status: account.status,
      is_2fa_enabled: account.is_2fa_enabled,
      survey_access: account.survey_access,
      team_member_mapping_emails: account.team_member_mapping_emails,
      is_custom_login: account.is_custom_login,
      login_methods: account.login_methods,
    }
  })
}

function canSeeOptionsV2(currentUser, user) {
  return roleLowerCase(user.role) !== 'owner' && user.email !== currentUser.email
}

function canTransferOwnerShip(currentUser) {
  return roleLowerCase(currentUser.role) === 'owner'
}

function canConfigureTeamMemberMapping(user) {
  const unrestrictedFeedbackRoles = ['owner', 'admin', 'manager']
  return !unrestrictedFeedbackRoles.includes(roleLowerCase(user.role))
}

function roleLowerCase(role) {
  return role.toLowerCase()
}

export function getRolesAndSurveyAccessVisibility(roles) {
  return [roles, getSurveyAccessSelectableRoles(roles), getDashboardAccessSelectableRoles(roles)]
}

function getSurveyAccessSelectableRoles(roles) {
  return roles
    .filter((role) => role.view_surveys_page === 'restricted_per_account')
    .map((role) => role.name)
}

function getDashboardAccessSelectableRoles(roles) {
  return roles
    .filter((role) => role.view_custom_dashboards === 'restricted_per_account')
    .map((role) => role.name)
}

function getAuthorizedDashboardTokens(dashbardAccesses) {
  return dashbardAccesses
    .filter((dashboard) => dashboard.has_permission)
    .map((dashboard) => dashboard.token)
}

export const ACCOUNTS_URL = 'account/accounts/?limit=10000'



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/domains/user/index.js